import React from 'react';

import { cn } from 'lib/helpers/utility';

import Popover from '../Popovers/Popover/Popover';

const MoreMenu = ({
  items,
  activeValue,
  onSelect,
  className,
  buttonClassName,
  textClassName = 'text-neutral-800'
}) => {
  const options = items.map((item) => ({
    ...item,
    textClassName: 'text-neutral-900',
    ...(activeValue !== undefined && item.value === activeValue && { color: 'primary' }),
    ...(item.actions && {
      component: ({ handleClose }) => (
        <Popover
          isFixed
          options={item.actions}
          placement="bottom-end"
          buttonClassName="border-none"
          icon="context-menu-horizontal"
          position="left"
          onOptionClick={handleClose}
          iconColor="neutral"
          iconsShade={700}
          textClassName="text-neutral-900"
          optionIconColor="neutral"
        />
      )
    }),
    onClick: () => onSelect(item)
  }));

  return (
    <Popover
      buttonTheme="neutral"
      className={className}
      isFixed
      buttonClassName={cn('rounded-md bg-transparent !min-h-7 !h-7', buttonClassName)}
      textClassName={textClassName}
      optionGroupLabelClassName="text-neutral-800"
      options={options}
      placement="bottom-end"
      text="More"
      isDropdown
      optionIconSize={16}
      optionIconColor="neutral"
      iconRightColor="neutral-800"
      iconsShade={600}
      icon=""
      menuPortalTarget={document.body}
      panelClassName="overflow-auto max-h-[500px]"
    />
  );
};

export default MoreMenu;
